import React from 'react'
import { URL_FACEBOOK, URL_SOUNDCLOUD, URL_TWITTER } from '../../constants'

function PerformanceSocial() {

  return (
    <div>
      {/*<span className="content-title">Prestations</span>*/}

      <div className="card-panel">

      <p className="justify">
        Découvrez les évènements fanfare passés et futurs du Baudet sur votre réseau social préféré :
      </p>

      <div className="row center">

        <div className="col s12 m6 l4"><a
          className="grey-text text-lighten-3 waves-effect waves-light btn facebook-button"
          href={ URL_FACEBOOK } target="_blank" rel="noopener"><i className="material-icons left">thumb_up</i>Facebook</a><br/>&nbsp;
        </div>
        <div className="col s12 m6 l4"><a2
          className="grey-text text-lighten-3 waves-effect waves-light btn twitter-button"
          href={ URL_TWITTER } target="_blank" rel="noopener"><i
          className="material-icons left">repeat</i>Twitter</a2><br/>&nbsp;
        </div>
        <div className="col s12 m6 l4"><a
            className="grey-text text-lighten-3 waves-effect waves-light btn soundcloud-button"
            href={ URL_SOUNDCLOUD } target="_blank" rel="noopener"><i
            className="material-icons left">cloud</i>Soundcloud</a><br/>&nbsp;
        </div>

      </div>

      <p className="justify">
        N'hésitez par à <b>Liker</b> et à <b>Partager</b> !
      </p>

    </div>
    </div>
  );

}

export default PerformanceSocial;



/** WEBPACK FOOTER **
 ** ./src/components/Performances/PerformanceSocial.js
 **/